import { TaxrateService } from './../../../../configurations/inventory/setup/taxrate/taxrate.service';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { convertToMaxValue } from './../../../../modules/shared/validators/convert-to-maximum.validator';
import { convertToAbsolute } from './../../../../modules/shared/validators/convert-to-absolute.validator';
import { SalesOrderService } from './../../../../inventory/sales-order/sales-order.service';
import { FormErrorHandler } from './../../../../modules/shared/helpers/form-error-handler.helper';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { WorkflowModelsNS } from '../../models/add-update-workflow.models';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { scrollToError } from '../../../../modules/shared/helpers/scroll-to-error.helper';
import { Status, WorkflowUpdateRecordValueTypeEnum } from 'src/app/models/statusEnums';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';
import { EstimateOrderModuleId, InvoiceOrderModuleId, SOModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { AppMainService } from 'src/app/app-main.service';
import { SharedTemplateService } from 'src/app/modules/shared/services/template.service';
import { MessageService } from 'primeng/api';
import { LeadAccountUpdateFieldsModel } from '../../models/lead-account-update-fields.models';
import { FormControlList, FormControlListIds } from 'src/app/modules/shared/constants/formcontrol-list.constants';
import { customFieldTagRegex } from 'src/app/modules/shared/constants/custom-field-tag.regex';

@Component({
    selector: 'app-workflow-update-record-dialog',
    templateUrl: './workflow-update-record-dialog.component.html',
    styleUrls: ['./workflow-update-record-dialog.component.scss']
})

export class WorkflowUpdateRecordDialogComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() viewOnly: boolean = false;
    @Input() displayUpdateRecordDialog: boolean = false;
    @Input() display: boolean = false;
    @Input() selectedParentModule: SavedSearchNS.IObjectType;
    @Input() selectedActionModule: any = null;
    @Input() selectedActionUpdateRecord: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord = null;
    @Input() selectedParentTemplate: SavedSearchNS.ITemplate;// Parent module Template
    @Output() savedUpdateRecord = new EventEmitter<WorkflowModelsNS.WorkflowAddEditActionUpdateRecord>();
    @Output() dialogClosed = new EventEmitter<boolean>();
    selectedModule: { objectId: number, name: string } = null;
    popupHeader: string = "Update Record";
    headerText: string = "Select Product";

    //Update Record
    updateRecordForm: FormGroup;
    formSubmitted: boolean = false;
    loadingFormSave: boolean = false;
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();

    //Dropdown Values
    dropdownIcon: string = 'fa fa-caret-down';
    updateRecordTypeEnum = WorkflowModelsNS.WorkflowUpdateRecordDiscountType;
    updateRecordType = [
        {
            id: WorkflowModelsNS.WorkflowUpdateRecordDiscountType.FreeProduct,
            name: WorkflowModelsNS.WorkflowUpdateRecordOfferTypes[WorkflowModelsNS.WorkflowUpdateRecordDiscountType.FreeProduct]
        },
        {
            id: WorkflowModelsNS.WorkflowUpdateRecordDiscountType.DiscountAmount,
            name: WorkflowModelsNS.WorkflowUpdateRecordOfferTypes[WorkflowModelsNS.WorkflowUpdateRecordDiscountType.DiscountAmount]
        },
        {
            id: WorkflowModelsNS.WorkflowUpdateRecordDiscountType.QtyDiscount,
            name: WorkflowModelsNS.WorkflowUpdateRecordOfferTypes[WorkflowModelsNS.WorkflowUpdateRecordDiscountType.QtyDiscount]
        },
        {
            id: WorkflowModelsNS.WorkflowUpdateRecordDiscountType.AdditionalHandlingCharge,
            name: WorkflowModelsNS.WorkflowUpdateRecordOfferTypes[WorkflowModelsNS.WorkflowUpdateRecordDiscountType.AdditionalHandlingCharge]
        },
        {
            id: WorkflowModelsNS.WorkflowUpdateRecordDiscountType.QtyHandlingCharge,
            name: WorkflowModelsNS.WorkflowUpdateRecordOfferTypes[WorkflowModelsNS.WorkflowUpdateRecordDiscountType.QtyHandlingCharge]
        },
        {
            id: WorkflowModelsNS.WorkflowUpdateRecordDiscountType.TaxRateHandling,
            name: WorkflowModelsNS.WorkflowUpdateRecordOfferTypes[WorkflowModelsNS.WorkflowUpdateRecordDiscountType.TaxRateHandling]
        }
    ];

    configDiscountsList: any[] = [];
    configHandlingFees: any[] = [];
    discountOptions: any[] = [];
    offerDiscountOptions: any[] = [];
    allProducts: {id: number, name: string}[] = [];
    offerOnProducts: {id: number, name: string}[] = [];
    offeredProducts: {id: number, name: string}[] = [];

    //update record
    orderedProducts = [
        {id:1,itemNo:"SO5555",description:"Item 1",avgqty:50,uom:"Each",rate:"$1000"},
        {id:2,itemNo:"SO5556",description:"Item 2",avgqty:20,uom:"Each",rate:"$100"},
        {id:3,itemNo:"SO5557",description:"Item 3",avgqty:500,uom:"Each",rate:"$100"},
    ]
    offeredProducts1 = [
        {id:1,itemNo:"SO5555",description:"Item 1",freeqty:50,uom:"Each",rate:"$1000",discount:"5%"},
        {id:2,itemNo:"SO5556",description:"Item 2",freeqty:20,uom:"Each",rate:"$100",discount:"10%"},
        {id:3,itemNo:"SO5557",description:"Item 3",freeqty:500,uom:"Each",rate:"$100",discount:"8%"},
    ];
    displayCreateRecord = false;

    qtyProducts = [];
    tempQtyProduct = {
        id:0,operator:{},orderQty:0,orderQtyFrom:0,orderQtyTo:0,rate:"",discount:""
    }

    workflowOfferedQtyOperators = WorkflowModelsNS.WorkflowOfferedQtyOperators;

    qtyOperators = [
        {
            id: WorkflowModelsNS.WorkflowOfferedQtyOperators.IsGreaterThan,
            name: WorkflowModelsNS.WorkflowOfferedQtyOperatorNames[WorkflowModelsNS.WorkflowOfferedQtyOperators.IsGreaterThan]
        },
        {
            id: WorkflowModelsNS.WorkflowOfferedQtyOperators.IsLessThan,
            name: WorkflowModelsNS.WorkflowOfferedQtyOperatorNames[WorkflowModelsNS.WorkflowOfferedQtyOperators.IsLessThan]
        },
        {
            id: WorkflowModelsNS.WorkflowOfferedQtyOperators.IsEqualTo,
            name: WorkflowModelsNS.WorkflowOfferedQtyOperatorNames[WorkflowModelsNS.WorkflowOfferedQtyOperators.IsEqualTo]
        },
        {
            id: WorkflowModelsNS.WorkflowOfferedQtyOperators.IsNotEqualTo,
            name: WorkflowModelsNS.WorkflowOfferedQtyOperatorNames[WorkflowModelsNS.WorkflowOfferedQtyOperators.IsNotEqualTo]
        },
        {
            id: WorkflowModelsNS.WorkflowOfferedQtyOperators.IsGreaterThanEqualTo,
            name: WorkflowModelsNS.WorkflowOfferedQtyOperatorNames[WorkflowModelsNS.WorkflowOfferedQtyOperators.IsGreaterThanEqualTo]
        },
        {
            id: WorkflowModelsNS.WorkflowOfferedQtyOperators.Between,
            name: WorkflowModelsNS.WorkflowOfferedQtyOperatorNames[WorkflowModelsNS.WorkflowOfferedQtyOperators.Between]
        },
        {
            id: WorkflowModelsNS.WorkflowOfferedQtyOperators.NotBetween,
            name: WorkflowModelsNS.WorkflowOfferedQtyOperatorNames[WorkflowModelsNS.WorkflowOfferedQtyOperators.NotBetween]
        },
        {
            id: WorkflowModelsNS.WorkflowOfferedQtyOperators.IsLessThanEqualTo,
            name: WorkflowModelsNS.WorkflowOfferedQtyOperatorNames[WorkflowModelsNS.WorkflowOfferedQtyOperators.IsLessThanEqualTo]
        }
    ]

    //Add Product
    productAddType: 'offerOn' | 'offered' = "offerOn";
    selectionMode: 'multiple'|'single' = 'single';
    selectedOfferOnProducts: any[] = [];
    selectedOfferedProducts: any[] = [];
    displayProductSelectionModal: boolean = false;
    selectedProductsList: any = null;
    selectedLocationId: number = null;

    //Tax exempted
    taxExemptedOptions: any[] = [
        {id: 1, name: 'All Products'},
        {id: 2, name: 'Individual Products'}
    ];
    taxList: any[] = [];

     // fraction digits
     fractionDigits: number = 0;
     qtyFractionDigits: number = 0;
     measurementUnits  = [];
     decimalPlacesMap: { [key: number]: number } = {};

     //Add expression
     displayAddExpression: boolean = false;
     expressionText: string = "";
     salesOrderModuleId: number = SOModuleId;
     estimateOrderModuleId: number = EstimateOrderModuleId;
     invoiceOrderModuleId: number = InvoiceOrderModuleId;
     availableFieldsForExpression: SavedSearchNS.IField[] = [];
     hiddenChildFields: string[] = ['contactEmail','phone'];
     hiddenFields: string[] = [
        'sequenceNumber','phone','contactEmail',
        'contactname','contactFirstName','contactMiddleName','contactLastName',
        'social','businessName','work','mainCustomer',
        'name','forcastCategory','probability',
        'createdDate','createdByUserName','updatedDate','updatedByUserName',
        'previousStageOwner', 'stageChangedBy','previousStage','stageChangedDate'
    ];
    selectedChannelId: number = 0;
    addedFieldTags: string[] = [];

    constructor(
        private formBuilder: FormBuilder,
        private salesOrderService: SalesOrderService,
        private importService: ImportserialService,
        private taxService: TaxrateService,
        private appMainService: AppMainService,
        private sharedTemplateService: SharedTemplateService,
        private messageService: MessageService,
    ){}

    ngOnInit(): void {
        this.selectModuleAndChannel();
        this.initForm();
        this.loadTaxList();
        this.getAllGroup();
        this.getDiscounts();
        this.getAdditionalFees();
        this.getFractionDigits();
        this.getQtyDecimalDigits();
        this.fetchUnitOfMeasureCategories();
    }

    selectModuleAndChannel(){
        if(this.selectedActionModule?.objectId && this.selectedActionModule?.objectId!=this.selectedParentModule?.objectId){
            this.selectedModule = ParseHelper.DeepCopy(this.selectedActionModule);
            this.selectedChannelId = this.selectedActionModule.channelId;
        }else{
            this.selectedModule = ParseHelper.DeepCopy(this.selectedParentModule);
        }

        this.popupHeader = `${this.selectedModule.name} Update Record`;

        if(!this.viewOnly){
            this.
            generateAvailableFieldsForExpressionFromParentModules();
        }
       
    }

    //#region ***Update Record Form***

    initForm(){
        this.detailsFormErrors = {};
        this.isUnsavedData = false;

        const offerDiscountTypeId = (![this.updateRecordTypeEnum.DiscountAmount,this.updateRecordTypeEnum.AdditionalHandlingCharge].includes(this.selectedActionUpdateRecord?.offerType) && this.selectedActionUpdateRecord?.discountTypeId) ? this.selectedActionUpdateRecord?.discountTypeId : null;
        const offerDiscountAmount = (![this.updateRecordTypeEnum.DiscountAmount,this.updateRecordTypeEnum.AdditionalHandlingCharge].includes(this.selectedActionUpdateRecord?.offerType)) ? this.selectedActionUpdateRecord?.discountAmount : null;

        const discountId = ([this.updateRecordTypeEnum.DiscountAmount,this.updateRecordTypeEnum.AdditionalHandlingCharge].includes(this.selectedActionUpdateRecord?.offerType) && this.selectedActionUpdateRecord?.discountId) ? this.selectedActionUpdateRecord?.discountId : null;
        const discountTypeId = ([this.updateRecordTypeEnum.DiscountAmount,this.updateRecordTypeEnum.AdditionalHandlingCharge].includes(this.selectedActionUpdateRecord?.offerType) && this.selectedActionUpdateRecord?.discountTypeId) ? this.selectedActionUpdateRecord?.discountTypeId : null;
        const discountAmount = ([this.updateRecordTypeEnum.DiscountAmount,this.updateRecordTypeEnum.AdditionalHandlingCharge].includes(this.selectedActionUpdateRecord?.offerType) && this.selectedActionUpdateRecord?.discountAmount) ? this.selectedActionUpdateRecord?.discountAmount : null;


        this.selectedOfferOnProducts = this.selectedActionUpdateRecord?.offerOnProduct ? [this.selectedActionUpdateRecord?.offerOnProduct] : [];
        this.selectedOfferedProducts = this.selectedActionUpdateRecord?.offeredProduct ? [this.selectedActionUpdateRecord?.offeredProduct] : [];

        const offerType = this.selectedActionUpdateRecord?.offerType||this.updateRecordTypeEnum.FreeProduct;

        this.updateRecordForm = this.formBuilder.group({
            id: [this.selectedActionUpdateRecord?.id||0],
            offerType: [{value: offerType, disabled: (this.viewOnly || this.selectedActionUpdateRecord?.id)}],
            offerOnLocationId: [this.selectedActionUpdateRecord?.offerOnLocationId || null],
            offerOnProduct: [this.selectedActionUpdateRecord?.offerOnProduct||null],
            offerOnProductUOMId: [this.selectedActionUpdateRecord?.offerOnProductUOMId || null],
            minOrderQty: [this.selectedActionUpdateRecord?.minOrderQty||null],
            offeredLocationId: [this.selectedActionUpdateRecord?.offeredLocationId || null],
            offeredProduct: [this.selectedActionUpdateRecord?.offeredProduct||null],
            offeredProductUOMId: [this.selectedActionUpdateRecord?.offeredProductUOMId || null],
            offeredQty: [this.selectedActionUpdateRecord?.offeredQty||null],
            discountId: [discountId],
            discountTypeId: [discountTypeId],
            discountAmount: [discountAmount],
            taxRateId: [this.selectedActionUpdateRecord?.taxRateId||0],
            taxExempted: [this.selectedActionUpdateRecord?.isTaxExempted ? 1 : 2],
            offerDiscountTypeId: [{value: offerDiscountTypeId, disabled: true}],
            offerDiscountAmount: [offerDiscountAmount, [Validators.max(100), convertToAbsolute, convertToMaxValue(100)]],
            isAdditionalDiscount: [true],
            workflowUpdateRecordQtyDiscounts: this.formBuilder.array([]),
            taxExemptedProducts: this.formBuilder.array([]),
            maxLengthAfterDecimal: [2],
            fieldValueType: [this.selectedActionUpdateRecord?.fieldValueType || WorkflowUpdateRecordValueTypeEnum.Value],
            expressionValue: [this.selectedActionUpdateRecord?.expressionValue||null],
            workflowUpdateRecordExpressionFields: [this.selectedActionUpdateRecord?.workflowUpdateRecordExpressionFields||[]],
        });

        if(this.viewOnly){
            this.updateRecordForm.disable();
        }

        this.formErrorHandler.handleErrors(this.updateRecordForm, this.detailsFormErrors, {
            offerType: {
                required: "Select any update type"
            },
            offerOnProduct: {
                required: "Select offer on product"
            },
            minOrderQty: {
                required: "Enter order quantity"
            },
            offeredProduct: {
                required: "Select offer product"
            },
            offeredQty: {
                required: "Enter offer quantity"
            },
            discountAmount: {
                required: "Enter discount value"
            },
        });

        this.updateRecordForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(e => this.isUnsavedData = true);

        if(this.selectedActionUpdateRecord?.workflowUpdateRecordQtyDiscounts?.length>0){
            this.selectedActionUpdateRecord?.workflowUpdateRecordQtyDiscounts.filter(q=> q.statusId==Status.Active).map(qtyDiscounts=>{
                this.addQtyDiscount(qtyDiscounts);
            })
        }

        if(this.selectedActionUpdateRecord && this.updateRecordForm.getRawValue().offerType==this.updateRecordTypeEnum.TaxRateHandling && this.updateRecordForm.getRawValue().taxExempted==2){
            const taxProduct: any = {
                id: this.selectedActionUpdateRecord.id,
                workflowActionId: this.selectedActionUpdateRecord.workflowActionId,
                offerOnProduct: this.selectedActionUpdateRecord.offerOnProduct,
                minOrderQty: this.selectedActionUpdateRecord.minOrderQty,
                offerOnProductUOMId: this.selectedActionUpdateRecord.offerOnProductUOMId||null,
                offerOnLocationId: this.selectedActionUpdateRecord.offerOnLocationId,
                taxRateId: this.selectedActionUpdateRecord.taxRateId
            }

            this.addTaxProduct(taxProduct);
        }

        this.updateValidation(this.updateRecordForm.getRawValue().offerType, true);

        if(offerType==this.updateRecordTypeEnum.AdditionalHandlingCharge){
            this.updateDiscountValidation(this.updateRecordForm.getRawValue().discountId,this.configHandlingFees);
        }else{
            this.updateDiscountValidation(this.updateRecordForm.getRawValue().discountId,this.configDiscountsList);
        }

        this.updateRecordForm.get('offerType')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(offerType => {
                this.selectedOfferedProducts = [];
                this.selectedOfferOnProducts = [];
                this.updateRecordForm.patchValue({
                    offerOnProduct: null,
                    offeredProduct: null
                },{onlySelf: true, emitEvent: false});
                this.updateValidation(offerType);
            });
    }

    initQtyDiscounts(qtyDiscount: WorkflowModelsNS.WorkflowAddEditActionRecordQtyDiscount){
        const qtyDiscountForm = this.formBuilder.group({
            id: [qtyDiscount?.id||0],
            workflowActionUpdateRecordId: [qtyDiscount?.workflowActionUpdateRecordId||this.updateRecordForm.getRawValue().id],
            operator: [qtyDiscount?.operator||null, [Validators.required]],
            fromOrderedQty: [qtyDiscount?.fromOrderedQty||null, [Validators.required, convertToAbsolute]],
            toOrderedQty: [qtyDiscount?.toOrderedQty||0, [convertToAbsolute]],
            discountId: [qtyDiscount?.discountId],
            discountTypeId: [qtyDiscount?.discountTypeId||null],
            discountAmount: [qtyDiscount?.discountAmount||null, [Validators.required, convertToAbsolute]],
            statusId: [qtyDiscount?.statusId||1],
        });

        if(this.viewOnly){
            qtyDiscountForm.disable();
        }

        return qtyDiscountForm;
    }

    changeQtyDiscountType({ value }, qtyForm: FormGroup, updateValue: boolean = true, configList: any[]){

        const selectedDiscount = configList.find(discount=> discount.id==value);

        if(selectedDiscount && updateValue){
            qtyForm.patchValue({
                discountTypeId: selectedDiscount?.type?.id||null,
                discountAmount: selectedDiscount?.discountValue||null
            });
        }

        if(selectedDiscount){
            const amountControl = qtyForm.get('discountAmount');

            if(selectedDiscount?.name=='Manual' && selectedDiscount?.createdSource=='System'){
                amountControl.enable();
            }else{
                amountControl.disable();
            }

            amountControl.updateValueAndValidity();
        }

        let maxValue = 100;

        if(selectedDiscount?.type?.description=='%'){
            maxValue = 100;
        }else if(this.selectedOfferOnProducts.length > 0){
            maxValue = this.selectedOfferOnProducts[0]?.sellPrice||0;
        }

        let validations = [Validators.required, convertToAbsolute];

        if(this.updateRecordForm.getRawValue().offerType==this.updateRecordTypeEnum.QtyDiscount){
            validations = [Validators.required, Validators.max(maxValue), convertToAbsolute, convertToMaxValue(maxValue)];
        }

        this.updateControlValidation(qtyForm,'discountAmount',[Validators.required, Validators.max(maxValue), convertToAbsolute, convertToMaxValue(maxValue)]);
    }

    getAddedQtyDiscounts(form) {
        return form.controls.workflowUpdateRecordQtyDiscounts.controls;
    }

    addQtyDiscount(qtyDiscount: WorkflowModelsNS.WorkflowAddEditActionRecordQtyDiscount = null) {
        const control = <FormArray>this.updateRecordForm.get('workflowUpdateRecordQtyDiscounts');
        control.push(this.initQtyDiscounts(qtyDiscount));
    }

    removeQtyDiscount(index: number) {
        const control = <FormArray>this.updateRecordForm.get('workflowUpdateRecordQtyDiscounts');
        control.removeAt(index);
    }

    updateValidation(offerType: WorkflowModelsNS.WorkflowUpdateRecordDiscountType, clearValues: boolean = false){

        switch(offerType){
            case this.updateRecordTypeEnum.FreeProduct:
                if(clearValues){
                    const control = <FormArray>this.updateRecordForm.get('workflowUpdateRecordQtyDiscounts');
                    control.clear();
                }

                this.updateControlValidation(this.updateRecordForm,'offerOnProduct',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'offerOnProductUOMId',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'minOrderQty',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'offeredProduct',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'offeredProductUOMId',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'offeredQty',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'offerDiscountAmount',[Validators.max(100), convertToAbsolute, convertToMaxValue(100)]);
                this.updateControlValidation(this.updateRecordForm,'discountAmount',[]);
                this.updateControlValidation(this.updateRecordForm,'discountId',[]);
                this.updateControlValidation(this.updateRecordForm,'workflowUpdateRecordQtyDiscounts',[]);
                this.updateControlValidation(this.updateRecordForm,'taxExemptedProducts',[]);
                break;
            case this.updateRecordTypeEnum.AdditionalHandlingCharge:
            case this.updateRecordTypeEnum.DiscountAmount:
                if(clearValues){
                    const control = <FormArray>this.updateRecordForm.get('workflowUpdateRecordQtyDiscounts');
                    control.clear();
                }

                if(!clearValues){
                    this.updateRecordForm.patchValue({
                        discountId: null,
                        discountTypeId: null,
                        discountAmount: null
                    })
                }

                this.updateControlValidation(this.updateRecordForm,'offerOnProduct',[]);
                this.updateControlValidation(this.updateRecordForm,'offerOnProductUOMId',[]);
                this.updateControlValidation(this.updateRecordForm,'minOrderQty',[]);
                this.updateControlValidation(this.updateRecordForm,'offeredProduct',[]);
                this.updateControlValidation(this.updateRecordForm,'offeredProductUOMId',[]);
                this.updateControlValidation(this.updateRecordForm,'offeredQty',[]);
                this.updateControlValidation(this.updateRecordForm,'discountId',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'discountAmount',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'workflowUpdateRecordQtyDiscounts',[]);
                this.updateControlValidation(this.updateRecordForm,'taxExemptedProducts',[]);
                break
            case this.updateRecordTypeEnum.QtyHandlingCharge:
            case this.updateRecordTypeEnum.QtyDiscount:
                if(!clearValues){
                    const control = <FormArray>this.updateRecordForm.get('workflowUpdateRecordQtyDiscounts');
                    control.clear();
                }
                this.updateControlValidation(this.updateRecordForm,'offerOnProduct',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'offerOnProductUOMId',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'minOrderQty',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'workflowUpdateRecordQtyDiscounts',[Validators.required]);
                this.updateControlValidation(this.updateRecordForm,'taxExemptedProducts',[]);
                this.updateControlValidation(this.updateRecordForm,'offeredProduct',[]);
                this.updateControlValidation(this.updateRecordForm,'offeredProductUOMId',[]);
                this.updateControlValidation(this.updateRecordForm,'offeredQty',[]);
                this.updateControlValidation(this.updateRecordForm,'offerDiscountAmount',[]);
                this.updateControlValidation(this.updateRecordForm,'discountAmount',[]);
                this.updateControlValidation(this.updateRecordForm,'discountId',[]);
                break
            case this.updateRecordTypeEnum.TaxRateHandling:
                if(!clearValues){
                    const control1 = <FormArray>this.updateRecordForm.get('taxExemptedProducts');
                    control1.clear();
                    const control = <FormArray>this.updateRecordForm.get('workflowUpdateRecordQtyDiscounts');
                    control.clear();
                }

                this.updateControlValidation(this.updateRecordForm,'offerOnProduct',[]);
                this.updateControlValidation(this.updateRecordForm,'offerOnProductUOMId',[]);
                this.updateControlValidation(this.updateRecordForm,'minOrderQty',[]);
                this.updateControlValidation(this.updateRecordForm,'workflowUpdateRecordQtyDiscounts',[]);
                this.updateControlValidation(this.updateRecordForm,'offeredProduct',[]);
                this.updateControlValidation(this.updateRecordForm,'offeredProductUOMId',[]);
                this.updateControlValidation(this.updateRecordForm,'offeredQty',[]);
                this.updateControlValidation(this.updateRecordForm,'offerDiscountAmount',[]);
                this.updateControlValidation(this.updateRecordForm,'discountAmount',[]);
                this.updateControlValidation(this.updateRecordForm,'discountId',[]);
                if(this.updateRecordForm.getRawValue().taxExempted==1){
                    this.updateControlValidation(this.updateRecordForm,'taxExemptedProducts',[]);
                }else{
                    this.updateControlValidation(this.updateRecordForm,'taxExemptedProducts',[Validators.required]);
                }
                break
            default:
                break;
        }
    }

    updateControlValidation(form: FormGroup, controlName: string, validation: any[]){
        const control = form.get(controlName);

        if(control){
            control.setValidators(validation);
            control.updateValueAndValidity();
        }
    }

    updateDiscountValidation(discountId: number, configList: any[]){
        const selectedDiscount = configList.find(discount=> discount.id==discountId);

        if(selectedDiscount){
            this.discountOptions = selectedDiscount?.type ? [selectedDiscount.type] : [];
            const typeControl = this.updateRecordForm.get('discountTypeId');
            const amountControl = this.updateRecordForm.get('discountAmount');

            if(selectedDiscount?.name=='Manual' && selectedDiscount?.createdSource=='System'){
                amountControl.enable();
            }else{
                amountControl.disable();
            }

            typeControl.disable();
            typeControl.updateValueAndValidity();
            amountControl.updateValueAndValidity();
        }
    }

    updateQtyDiscountsValidation(configList: any[]){
        this.getAddedQtyDiscounts(this.updateRecordForm).map(qtyForm=>{
            if(qtyForm?.value?.discountId){
                this.changeQtyDiscountType({value: qtyForm?.value?.discountId}, qtyForm, false, configList)
            }
        });
    }

    saveUpdateRecord(){
        this.updateValidation(this.updateRecordForm.getRawValue().offerType, true);
        if(this.updateRecordForm.invalid){
            this.updateRecordForm.markAllAsTouched();
            this.updateRecordForm.markAsDirty();
            this.formErrorHandler.showErrorOnSubmit();
            scrollToError();
            return;
        }

        const formValue = this.updateRecordForm.getRawValue();

        let updateRecordData: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord = {
            id: this.selectedActionUpdateRecord?.id||0,
            workflowActionId: this.selectedActionUpdateRecord?.workflowActionId||0,
            objectId: this.selectedModule.objectId,
            objectName: this.selectedModule.name,
            offerType: formValue.offerType,
            offerOnProductId: 0,
            minOrderQty: 0,
            offeredProductId: 0,
            offeredQty: 0,
            discountId: formValue.discountId,
            discountTypeId: formValue.discountTypeId,
            discountAmount: formValue.discountAmount,
            isAdditionalDiscount: true,
            offerOnLocationId: 0,
            offerOnProductUOMId: 0,
            offeredLocationId: 0,
            offeredProductUOMId: 0,
            taxRateId: 0,
            isTaxExempted: false,
            workflowUpdateRecordQtyDiscounts: [],
            taxExemptedProducts: [],
            statusId: 1,
            maxLengthAfterDecimal: formValue.maxLengthAfterDecimal,
            fieldValueType: formValue.fieldValueType,
            expressionValue: formValue.expressionValue,
            workflowUpdateRecordExpressionFields: [],
        }

        if(formValue.offerType==this.updateRecordTypeEnum.QtyDiscount || formValue.offerType==this.updateRecordTypeEnum.QtyHandlingCharge){
            updateRecordData = {
                ...updateRecordData,
                offerType: formValue.offerType,
                offerOnProduct: formValue.offerOnProduct,
                offerOnProductId: formValue.offerOnProduct.id,
                minOrderQty: formValue.minOrderQty,
                offerOnLocationId: formValue.offerOnLocationId,
                offerOnProductUOMId: formValue.offerOnProductUOMId,
                workflowUpdateRecordQtyDiscounts: formValue.workflowUpdateRecordQtyDiscounts,
                offeredProduct: null,
                offeredProductId: 0,
                offeredQty: 0,
                discountId: 0,
                discountTypeId: 0,
                discountAmount: 0,
                offeredLocationId: 0,
                offeredProductUOMId: 0,
            }
        }else if(formValue.offerType==this.updateRecordTypeEnum.FreeProduct){
            updateRecordData = {
                ...updateRecordData,
                offerType: this.updateRecordTypeEnum.FreeProduct,
                offerOnProduct: formValue.offerOnProduct,
                offerOnProductId: formValue.offerOnProduct.id,
                minOrderQty: formValue.minOrderQty,
                offeredProduct: formValue.offeredProduct,
                offeredProductId: formValue.offeredProduct.id,
                offeredQty: formValue.offeredQty,
                discountId: 0,
                discountTypeId: formValue.offerDiscountTypeId,
                discountAmount: formValue.offerDiscountAmount||0,
                offerOnLocationId: formValue.offerOnLocationId,
                offerOnProductUOMId: formValue.offerOnProductUOMId,
                offeredLocationId: formValue.offeredLocationId,
                offeredProductUOMId: formValue.offeredProductUOMId,
            }
        }else if(formValue.offerType==this.updateRecordTypeEnum.TaxRateHandling && formValue.taxExempted==1){
            updateRecordData = {
                ...updateRecordData,
                isTaxExempted: !!(formValue.taxExempted==1),
                taxRateId: formValue.taxRateId,
                discountId: 0,
                discountTypeId: 0,
                discountAmount: 0
            }
        }else if(formValue.offerType==this.updateRecordTypeEnum.TaxRateHandling && formValue.taxExempted==2){

            const addedTaxProducts = formValue.taxExemptedProducts||[];

            addedTaxProducts.map(taxProduct=>{
                const data: any = {
                    ...updateRecordData,
                    id: taxProduct.id,
                    workflowActionId: taxProduct.workflowActionId,
                    offerType: formValue.offerType,
                    offerOnProduct: taxProduct.offerOnProduct,
                    offerOnProductId: taxProduct.offerOnProduct.id,
                    minOrderQty: 1,
                    offerOnLocationId: taxProduct.offerOnLocationId,
                    offerOnProductUOMId: taxProduct.offerOnProductUOMId,
                    taxRateId: taxProduct.taxRateId,
                    isTaxExempted: false,
                    offeredProduct: null,
                    offeredProductId: 0,
                    offeredQty: 0,
                    discountId: 0,
                    discountTypeId: 0,
                    discountAmount: 0,
                    offeredLocationId: 0,
                    offeredProductUOMId: 0,
                }

                this.savedUpdateRecord.emit(data);
            })


        }
        if(formValue.fieldValueType== WorkflowUpdateRecordValueTypeEnum.Expresssion){
            this.updatedAddedTags(formValue.expressionValue);

            this.addedFieldTags.map((labelName, index )=>{
                const exist = this.availableFieldsForExpression.find(field=>field.labelname==labelName);
                if(exist){
                    let id = 0;

                    if(this.selectedActionUpdateRecord){
                        const addedField = this.selectedActionUpdateRecord.workflowUpdateRecordExpressionFields.find(field=>field.fieldName==exist.field);
                        id = addedField ? addedField.id : 0;
                    }

                    updateRecordData.workflowUpdateRecordExpressionFields.push({
                        id: id,
                        workflowActionUpdateRecordId: this.selectedActionUpdateRecord?.id||0,
                        fieldName: exist.field,
                        labelName: exist.labelname.trim(),
                        statusId: 1,
                        isCustom: exist.custom,
                        objectId: exist.objectId,
                        objectName: exist.objectName,
                        displayOrder: index,
                       
                    })
                }
            })
        }

        if(!(formValue.offerType==this.updateRecordTypeEnum.TaxRateHandling && formValue.taxExempted==2)){
            // Set removed qty discount
            if(this.selectedActionUpdateRecord?.workflowUpdateRecordQtyDiscounts?.length>0){
                this.selectedActionUpdateRecord.workflowUpdateRecordQtyDiscounts.map(addedQty=>{
                    const exist = updateRecordData.workflowUpdateRecordQtyDiscounts.find(qty=>qty.id==addedQty.id);
                    if(!exist && addedQty.id>0){
                        updateRecordData.workflowUpdateRecordQtyDiscounts.push({...addedQty,statusId: Status.Deleted});
                    }
                })
            }

            this.savedUpdateRecord.emit(updateRecordData);
        }

        this.closeUpdateRecord();
    }

    addEditOfferOnProduct(selectionMode: 'multiple'|'single' = 'single'){
        this.productAddType = 'offerOn';
        this.selectionMode = selectionMode;
        this.headerText = 'Select Ordered Product';
        this.selectedProductsList = this.updateRecordForm.getRawValue().offerOnProduct?.id? [this.updateRecordForm.getRawValue().offerOnProduct] : [];
        this.selectedLocationId = this.updateRecordForm.getRawValue().offerOnLocationId||null;
        this.displayProductSelectionModal = true;
    }

    addEditOfferedProduct(selectionMode: 'multiple'|'single' = 'single'){
        this.productAddType = 'offered';
        this.selectionMode = selectionMode;
        this.headerText = 'Select Offered Product';
        this.selectedProductsList = this.updateRecordForm.getRawValue().offeredProduct?.id ? [this.updateRecordForm.getRawValue().offeredProduct]: [];
        this.selectedLocationId = this.updateRecordForm.getRawValue().offeredLocationId||null;
        this.displayProductSelectionModal = true;
    }

    addProductFormat(x: any){
        x = ParseHelper.DeepCopy(x);
        let qty = x.totalQuantity ? Number(x.totalQuantity) : 1;

        if(x?.quantity){
            qty = x?.quantity;
        }

        let price = x.price ? parseFloat(x.price) : 0;

        if(x?.sellPrice){
            price = x?.sellPrice;
        }

        const addedProduct: WorkflowModelsNS.WorkflowAddEditActionRecordProductDetails = {
            id: x.id,
            name: x.itemNo,
            itemNo: x.itemNo,
            description: x.description,
            productUOM: [],
            quantity: qty,
            totalQuantity: qty,
            sellPrice: price,
            amount: qty * price,
            bundleDetails: null
        }

        if(x?.productUOM?.length>0){
            addedProduct.productUOM = x.productUOM;
        }else{
            x.uom?.map(uom=>{
                addedProduct.productUOM.push({
                    ...uom,
                    uomName: uom?.uomDetail?.name
                })
            });
        }

        let productUOMId = x?.unit?.uomDetail ? x.unit?.uomDetail?.id : null;

        if(x?.productUOMId){
            productUOMId = x?.productUOMId;
        }

        return {addedProduct, productUOMId}
    }

    onProductAddComplete(event) {

        if(this.selectionMode=='multiple' && [this.updateRecordTypeEnum.TaxRateHandling].includes(this.updateRecordForm.getRawValue().offerType)){
            this.onTaxProductAdd(event||[]);
            return;
        }

        const formatedProductDetails = this.addProductFormat(event);
        const productDetails = formatedProductDetails?.addedProduct;

        switch(this.productAddType){
            case 'offerOn':
                this.selectedOfferOnProducts = [productDetails];
                this.updateRecordForm.patchValue({
                    offerOnProduct: productDetails,
                    minOrderQty: productDetails.quantity,
                    offerOnProductUOMId: formatedProductDetails?.productUOMId||null
                });
                break;
            case 'offered':
                this.selectedOfferedProducts = [productDetails];
                this.updateRecordForm.patchValue({
                    offeredProduct: productDetails,
                    offeredQty: productDetails.quantity,
                    offerDiscountAmount: 100,
                    offeredProductUOMId: formatedProductDetails?.productUOMId||null
                });
                break;
        }

        this.displayProductSelectionModal = false;
	}

    onLocationSelect(event){
        if(this.selectionMode=='single'){
            switch(this.productAddType){
                case 'offerOn':
                    this.updateRecordForm.patchValue({
                        offerOnLocationId: event?.id
                    },{onlySelf: true, emitEvent: false});
                    break;
                case 'offered':
                    this.updateRecordForm.patchValue({
                        offeredLocationId: event?.id
                    },{onlySelf: true, emitEvent: false});
                    break;
            }
        }
    }

    selectAdditionalDiscount({ value }, configList: any[]){
        const selectedDiscount = configList.find(discount=> discount.id==value);
        if(selectedDiscount){
            this.discountOptions = selectedDiscount?.type ? [selectedDiscount.type] : [];
            this.updateRecordForm.patchValue({
                discountId: selectedDiscount.id,
                discountTypeId: selectedDiscount?.type?.id||null,
                discountAmount: selectedDiscount?.discountValue||null
            });
            this.updateDiscountValidation(value,configList);
        }
    }

    onProductCancelClicked($event){
        this.displayProductSelectionModal = false;
    }

    //#endregion

    //#region ***Dropdown Values***

    getDiscounts(){
        this.salesOrderService.getDiscounts(false).subscribe((res) => {
            this.configDiscountsList = res||[];

            this.configDiscountsList.map(discount=>{
                discount.description = `${ discount.description }(${discount?.type?.description||'$'})`
            })

            if(this.updateRecordForm.getRawValue().discountId && this.configDiscountsList?.length>0 && this.updateRecordForm.getRawValue().offerType==this.updateRecordTypeEnum.DiscountAmount){
                this.updateDiscountValidation(this.updateRecordForm.getRawValue().discountId,this.configDiscountsList);
            }

            if(this.updateRecordForm.getRawValue().workflowUpdateRecordQtyDiscounts?.length>0 && this.updateRecordForm.getRawValue().offerType==this.updateRecordTypeEnum.QtyDiscount){
                this.updateQtyDiscountsValidation(this.configDiscountsList);
            }
        });
    }

    getAdditionalFees(){
        this.salesOrderService.getAdditionalFees().subscribe((res) => {
            this.configHandlingFees = res||[];

            this.configHandlingFees.map(discount=>{
                discount.description = `${ discount.description }(${discount?.type?.description||'$'})`
            })

            if(this.updateRecordForm.getRawValue().discountId && this.configHandlingFees?.length>0 && this.updateRecordForm.getRawValue().offerType==this.updateRecordTypeEnum.AdditionalHandlingCharge){
                this.updateDiscountValidation(this.updateRecordForm.getRawValue().discountId,this.configHandlingFees);
            }

            if(this.updateRecordForm.getRawValue().workflowUpdateRecordQtyDiscounts?.length>0 && this.updateRecordForm.getRawValue().offerType==this.updateRecordTypeEnum.QtyHandlingCharge){
                this.updateQtyDiscountsValidation(this.configHandlingFees);
            }
        });
    }

    getAllGroup() {
        this.salesOrderService.getAllGroups().subscribe((res) => {
            const disGroupId = res.filter((r) => r?.name?.toLowerCase() == "discount type")[0].id;
            this.getAllDiscountByGroupId(disGroupId);
        });
    }

    getAllDiscountByGroupId(groupId) {
        this.salesOrderService.getGroupById(groupId).subscribe((res) => {
            this.offerDiscountOptions = res;

            if(!this.updateRecordForm.getRawValue().offerDiscountTypeId && this.offerDiscountOptions?.length>0){
                this.updateRecordForm.patchValue({
                    offerDiscountTypeId: this.offerDiscountOptions[0].id
                })
            }
        });
    }

    get offereDiscountTypeDes(){
        const selectedDiscount = this.offerDiscountOptions.find(discount=> discount.id==this.updateRecordForm.getRawValue().offerDiscountTypeId);
        return selectedDiscount?.description||"";
    }

    loadTaxList(status?) {
        this.taxService.getSetTaxConfig(status).subscribe((tax) => {
          if(tax){
            this.taxList = this.prepareTaxRateData(false, true, tax?.item2||[]);;
          }
        })
    }

    prepareTaxRateData(isParentSelectable, isChildSelectable, allTaxRates) {
        const taxRates = [];
        if (allTaxRates.length > 0) {
          for (let c of allTaxRates) {
            let ChildData = [];
            for (let s of c.tax) {
              let eachSub = {
                label: s.name,
                value: s,
                id: s.id,
                selectable: isChildSelectable,
                items: [],
              };
                if (s.statusId === 1) {
                    ChildData.push(eachSub);
                } else {
                    continue;
                }

              if (!this.selectedActionUpdateRecord?.taxRateId && s.isDefault) {
                this.updateRecordForm.patchValue({
                    taxRateId: eachSub.value.id
                });
              }
            }
            let eachData = {
              label: c.countryName,
              value: c,
              id: c.id,
              selectable: isParentSelectable,
              items: ChildData,
            };
            if (c.statusId === 1) {
                taxRates.push(eachData);;
            } else {
                continue;
            }
          }
        }
        return taxRates;
    }

    //#endregion

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    closeUpdateRecord(){
        this.displayUpdateRecordDialog = false;
        this.dialogClosed.emit(true);
    }

    //#region DecimalQuantity
     //quantity
    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => { },
            });
    }

    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }

    fetchUnitOfMeasureCategories() {
        this.salesOrderService.fetchUnitOfMeasureCategories().subscribe(resp => {
            this.measurementUnits = resp
        })
    }

    getDecimalPlacesCached(productUOM: any[], unitOfMeasureId: number): number {
        const uom = productUOM?.find(unit => unit.unitOfMeasureId === unitOfMeasureId);
        const categoryId = uom?.uomDetail?.categoryId;

        if (!categoryId) {
            return this.qtyFractionDigits; // Default fallback if categoryId is not found
        }
        delete this.decimalPlacesMap[categoryId];
        if (!(categoryId in this.decimalPlacesMap)) {
            this.decimalPlacesMap[categoryId] = this.getDecimalPlaces(categoryId);
        }
        return this.decimalPlacesMap[categoryId];
    }

    getDecimalPlaces(categoryId: number): number {
        return this.measurementUnits?.some(unit => unit.id === categoryId && unit.name?.toLowerCase() === 'count')
            ? 0
            : this.qtyFractionDigits;
    }

    //#endregion

    //#region tax exempted
    setTaxExempted($event){
        this.updateValidation(this.updateRecordForm.getRawValue().offerType);
    }

    onTaxProductAdd(addedProducts: any[]){
        addedProducts.map(product=>{
            const formatedProductDetails = this.addProductFormat(product);
            const productDetails = formatedProductDetails?.addedProduct;

            const taxProduct: any = {
                id: 0,
                workflowActionId: 0,
                offerOnProduct: productDetails,
                minOrderQty: productDetails.quantity,
                offerOnProductUOMId: formatedProductDetails?.productUOMId||null,
                offerOnLocationId: product?.warehouseId,
                taxRateId: null
            }

            this.addTaxProduct(taxProduct);
        });

        this.displayProductSelectionModal = false;
    }


    getAddedTaxProducts(form) {
        return form.controls.taxExemptedProducts.controls;
    }

    addTaxProduct(product: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord) {
        const control = <FormArray>this.updateRecordForm.get('taxExemptedProducts');
        control.push(this.initTaxProduct(product));
    }

    removeTaxProduct(index: number) {
        const control = <FormArray>this.updateRecordForm.get('taxExemptedProducts');
        control.removeAt(index);
    }

    initTaxProduct(product: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord){
        const taxProductForm = this.formBuilder.group({
            id: [product?.id||0],
            workflowActionId: [product?.workflowActionId],
            offerOnProduct: [product?.offerOnProduct||null],
            offerOnLocationId: [product?.offerOnLocationId],
            offerOnProductUOMId: [product?.offerOnProductUOMId||null],
            taxRateId: [product?.taxRateId||null,[Validators.required]]
        });

        if(this.viewOnly){
            taxProductForm.disable();
        }

        return taxProductForm;
    }

    //#endregion tax exempted

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    //update record
    addProduct(){
        this.displayCreateRecord = true;
    }

    //#region AddEditExpression
    openExpressionAdd() {
        this.expressionText = "";

        if (this.updateRecordForm.getRawValue().fieldValueType == WorkflowUpdateRecordValueTypeEnum.Expresssion && this.updateRecordForm.getRawValue().expressionValue) {
            this.expressionText = this.updateRecordForm.getRawValue().expressionValue;
        }

        this.displayAddExpression = true;
    }

    saveExpression(expressionData: { expressionText: string, addedFieldTags: string[] }) {
        this.updateRecordForm.patchValue({
            expressionValue: expressionData.expressionText,
            discountAmount:  this.updateRecordForm.getRawValue().discountAmount ?? 0,
            fieldValueType: expressionData.expressionText ? WorkflowUpdateRecordValueTypeEnum.Expresssion : WorkflowUpdateRecordValueTypeEnum.Value,
        });
        this.updatedAddedTags(expressionData.expressionText);
    }

    removeExpression() {
        this.updateRecordForm.patchValue({
            fieldValueType: WorkflowUpdateRecordValueTypeEnum.Value,
            expressionValue: null,
            workflowUpdateRecordExpressionFields: [],
        });
    }
    

    expressionDialogClose(){
        this.displayAddExpression = false;
    }

    updatedAddedTags(value: string) {
        this.addedFieldTags = [];
        if (value) {
            const addedTags: string[] = value.match(customFieldTagRegex) || [];
            addedTags.map(labelName => {
                const exist = this.availableFieldsForExpression.find(field => field.labelname.trim() == labelName.trim());

                if (exist) {
                    if (!this.addedFieldTags.includes(exist.labelname))
                        this.addedFieldTags.push(exist.labelname);
                }
            })
        }
    }

    generateAvailableFieldsForExpressionFromParentModules() {
        this.appMainService.isShowSpinner('getColumnSettings');
        this.sharedTemplateService.getTemplateSectionsForFormBuild(this.selectedParentModule?.objectId, this.selectedParentTemplate?.channelId).subscribe(
            {
                next: (response) => {
                    let columnList = response || [];
                    columnList.map((fields, i) => [
                        fields.customFields.map((customFields, i) => {
                            const formControlDetails: any = ParseHelper.DeepCopy(customFields.formControl);
                            customFields = {
                                ...customFields,
                                formControl: formControlDetails?.type,
                                formControlDetails: formControlDetails,
                                isCustom: true
                            }

                            fields.customFields[i] = customFields;
                        })
                    ]);
                    this.generateAvailableFieldsFromParentModules(columnList);
                    this.appMainService.isHideSpinner('getColumnSettings');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getColumnSettings');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                    });
                },
                complete: () => {

                },
            });
    }
    
    
        generateAvailableFieldsFromParentModules(columnList: any[]) {
            this.availableFieldsForExpression = [];
            columnList.map(sectionDetails => {
                if (!sectionDetails?.systemGenerated || sectionDetails.name.toLowerCase().includes('information') || (sectionDetails.name.toLowerCase().includes('details') && !sectionDetails.name.toLowerCase().includes('address'))) {
                    sectionDetails.fields.filter(f => !this.hiddenChildFields.includes(f.field)).map(field => {
                        if (field?.childFields?.length > 0) {
                            field.childFields.map(childField => {
                                this.setFieldDetails(childField, this.selectedParentModule);
                            })
                        } else {
                            this.setFieldDetails(field, this.selectedParentModule);
                        }
                    });
    
                    sectionDetails.customFields.map(field => {
                        this.setFieldDetails(field, this.selectedParentModule);
                    });
                }
            });
        }

        setFieldDetails(fieldDetails: LeadAccountUpdateFieldsModel, selectedModule: any){
                if(fieldDetails?.field && fieldDetails?.mapObject!='opportunityProduct' && !this.hiddenFields.includes(fieldDetails.field) &&
                    ![FormControlList.FileUpload,FormControlList.Picture,FormControlList.EncryptedText,FormControlList.AutoNumber,FormControlList.Formula].includes(fieldDetails.formControl)
                ){
                    const alwaysRequiredFields = ['stagename','currentstage','classificationame'];
                    const isRequried: boolean = (alwaysRequiredFields.includes(fieldDetails.field.toLowerCase()) || (fieldDetails?.isRequired||fieldDetails?.IsRequired||false));
                    const field: any = {
                        id: fieldDetails.id,
                        labelname: this.getFormatedName(fieldDetails),
                        name: fieldDetails.name,
                        objectId: selectedModule?.objectId,
                        objectName: selectedModule?.name,
                        code: fieldDetails.field,
                        isrequired: isRequried,
                        ischecked: true,
                        isShowInSetting: true,
                        isDuplicate: true,
                        isGlobalSearch: true,
                        width: "",
                        movable: false,
                        showForDrag: false,
                        templateId: this.selectedChannelId||0,
                        sectionId: 0,
                        custom: fieldDetails.isCustom,
                        formControlId: fieldDetails?.formControlDetails?.id||FormControlListIds[fieldDetails.formControl],
                        formControl: fieldDetails.formControl,
                        expression: fieldDetails?.formControlDetails?.expression,
                        pickListValues: fieldDetails?.formControlDetails?.pickListValues||[],
                        maxLengthAfterDecimal: fieldDetails?.formControlDetails?.maxLengthAfterDecimal||null,
                        field: fieldDetails.field,
                        mapObject: "",
                        isColumnSetting: true,
                        value: "",
                        displayOrder: 0,
                        fieldTypes: null,
                        fieldDataType: "String",
                        valueDataType: "String",
                        operators: [],
                        operatorsDD: [],
                        currencySymbol: fieldDetails?.currencySymbol
                    }
                    
                    if([FormControlList.Number,FormControlList.Decimal,FormControlList.Percentage].includes(fieldDetails.formControl)){               
                        this.availableFieldsForExpression.push(field);
                    }
                }
        }

    getFormatedName(fieldDetails: LeadAccountUpdateFieldsModel) {
        let labelName = fieldDetails.labelName;

        if (fieldDetails.mapObject == 'leadSocial') {
            labelName = `Lead ${fieldDetails.labelName}`
        }

        if (fieldDetails.mapObject == 'accountSocial') {
            labelName = `Account ${fieldDetails.labelName}`
        }

        return labelName;
    }

    get isAmountType(): boolean {
        return this.updateRecordForm?.get('discountTypeId')?.value === 740;
    }
}